import React, { Component } from "react";
import styled from "styled-components";
import { colors } from "../resources/ThemeColors";
import { breakpoints } from "../Media";
import { withRouter } from "react-router-dom";
import renderIf from "render-if";

const MainDiv = styled.div`
  height: auto;
  width: 40vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: white;
  padding: 1.5em;
  border-radius: 5px;

  @media (max-width: ${breakpoints.mobileMin}) {
    display: flex;
    flex-flow: column nowrap;
    align-items: center;
    justify-content: center;
    width: 80vw;
    padding: 1em;
  }

  @media (min-width: ${breakpoints.mobileMin}) and (max-width: ${breakpoints.mobileMax}) {
    display: flex;
    flex-flow: column nowrap;
    align-items: center;
    justify-content: center;
    margin-top: -3em;
    width: 50vw;
  }
`;

const TitleDiv = styled.div`
  height: auto;
  width: 100%;
  display: flex;
  align-items: flex-start;
`;

const Title = styled.h2`
  font-syle: normal;
  font-size: 1.5em;
  font-weight: 700;
  color: #3d3d3d !important;

  @media (max-width: ${breakpoints.mobileMin}) {
    font-size: 1.3em;
  }

  @media (min-width: ${breakpoints.mobileMin}) and (max-width: ${breakpoints.mobileMax}) {
  }
`;

const InputDiv = styled.div`
  height: auto;
  width: 90%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
`;

const InputBox = styled.input`
  width: 100%;
  height: 2.3em;
  border: 1px solid black;
  border-radius: 6px;
  margin-top: 1em;
  padding-left: 1.2em;
  font-size: 1em;
  font-weight: 400;

  :focus {
    outline: none;
  }

  @media (max-width: ${breakpoints.mobileMin}) {
    width: 100%;
    font-size: 0.9em;
  }

  @media (min-width: ${breakpoints.mobileMin}) and (max-width: ${breakpoints.mobileMax}) {
    width: 100%;
  }
`;

const Button = styled.button`
  height: 2.6em;
  width: 100%;
  background-color: ${colors.main};
  color: ${colors.light};
  border: 1px solid white;
  border-radius: 6px;
  margin-top: 1em;
  font-size: 1em;
  font-weight: 700;
  cursor: pointer;

  :hover {
    background-color: ${colors.light};
    color: ${colors.main};
    border: 1px solid ${colors.main};
  }
  :focus {
    outline: none;
  }

  @media (max-width: ${breakpoints.mobileMin}) {
    margin-top: 1em;
  }

  @media (min-width: ${breakpoints.mobileMin}) and (max-width: ${breakpoints.mobileMax}) {
    margin-top: 1em;
  }
`;

// const Links = styled.a``;

const Error = styled.p`
  color: red;
  font-weight: 500;
`;

class SearchCard extends Component {
  state = {
    location: "",
    service: "",
    error: null,
  };

  stateChange = (e) => {
    e.preventDefault();
    this.setState({ [e.target.name]: e.target.value });
  };
  onSearch = (e) => {
    e.preventDefault();
    if (this.state.service === "" || this.state.location === "") {
      this.setState({ error: "error" });
    } else {
      this.redirect();
    }
  };

  redirect = () => {
    if (this.state.location === "") {
      this.props.history.push({
        pathname: "/results",
        search: `?service=${this.state.service}`,
        state: { service: this.state.service },
      });
    } else {
      this.props.history.push({
        pathname: "/results",
        search: `?query=${this.state.service}&city=${this.state.location}`,
        state: { location: this.state.location, service: this.state.service },
      });
      localStorage.setItem("queryLocation", this.state.location);
    }
  };
  render() {
    return (
      <MainDiv>
        <TitleDiv>
          <Title>Search.Book.Go. Anytime. Wherever you are.</Title>
        </TitleDiv>
        <InputDiv>
          {renderIf(this.state.error !== null)(
            <Error>Please fill all the fields.</Error>
          )}
          <InputBox
            placeholder="Location"
            type="text"
            name="location"
            onChange={this.stateChange}
          ></InputBox>
          <InputBox
            placeholder="Service"
            type="text"
            name="service"
            onChange={this.stateChange}
          ></InputBox>
          <Button onClick={this.onSearch}>Search</Button>
        </InputDiv>
      </MainDiv>
    );
  }
}

export default withRouter(SearchCard);
